import clsx from "clsx";
import { makeStyles } from "@material-ui/core";
import DragHandleIcon from "@material-ui/icons/DragHandle";

const useStyles = makeStyles({
  root: {
    position: "absolute",
    top: 0,
    left: (props: any) => props.initialPosition,
    zIndex: 1,
    backgroundColor: "white",
    height: "100%",
    width: 11,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "1rem",
    boxSizing: "border-box",
    cursor: "w-resize",
    boxShadow:
      "0px 3px 3px -2px rgb(0 0 0 / 20%), -2px 3px 8px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)",
  },
});

interface IProps {
  maxWidth: number;
  minWidth: number;
  initialPosition: number;
  onBeforeMouseMove: Function;
  onMouseMove: Function;
  onMouseUp: Function;
}

const DragButton = ({
  maxWidth,
  minWidth,
  initialPosition,
  onBeforeMouseMove,
  onMouseMove,
  onMouseUp,
}: IProps) => {
  const classes = useStyles({ initialPosition });
  let isDragging = false;
  let offset = initialPosition;
  let width = 0;
  let ref: any = null;

  const handleMouseMoveWindow = (ev) => {
    offset = getOffset(ev.clientX);
    width = maxWidth - offset;

    moveButton(offset);
    onMouseMove(offset, width);
  };

  const handleMouseDownButton = () => {
    isDragging = true;
    getElement();
    onBeforeMouseMove();
    window.addEventListener("mousemove", handleMouseMoveWindow, false);
  };

  const handleMouseUpWindow = () => {
    if (!isDragging) return;

    window.removeEventListener("mousemove", handleMouseMoveWindow, false);
    onMouseUp(offset, width);
    isDragging = false;
  };

  const getOffset = (newOffset: number = 0) => {
    newOffset = newOffset > maxWidth ? maxWidth : newOffset;
    newOffset = newOffset < minWidth ? minWidth : newOffset;
    return newOffset;
  };

  const getElement = () => {
    ref = document.querySelector(".resize");
  };

  const moveButton = (offset: number) => {
    if (ref) ref.style.left = `${offset}px`;
  };

  // Remove evento ao soltar o mouse
  window.addEventListener("mouseup", handleMouseUpWindow, false);

  return (
    <div
      className={clsx("resize", classes.root)}
      onMouseDown={handleMouseDownButton}
    >
      <DragHandleIcon style={{ transform: "rotate(90deg)" }} />
    </div>
  );
};

export default DragButton;
